import React from "react";

import { ContentCarousel, StyledGrid } from "components/simple";
import PageFour from "./PageFour";
import PageOne from "./PageOne";
import PageThree from "./PageThree";
import PageTwo from "./PageTwo";

interface BgcScienceAppProps {
  registrationCode: string;
}

const BgcScienceApp: React.FC<BgcScienceAppProps> = ({ registrationCode }) => {
  const content = [
    {
      component: <PageOne />,
      buttonText: "Continue"
    },
    {
      component: <PageTwo />,
      buttonText: "Continue",
      showPrevious: true
    },
    {
      component: <PageThree />,
      buttonText: "Continue",
      showPrevious: true
    },
    {
      component: <PageFour registrationCode={registrationCode} />,
      showPrevious: true
    }
  ];

  return (
    <StyledGrid
      alignItems="center"
      container
      direction="column"
      fillRemainingHeight
      justifyContent="center"
    >
      <ContentCarousel content={content} />
    </StyledGrid>
  );
};

export default BgcScienceApp;
